// extracted by mini-css-extract-plugin
export var searchHeader = "_6l-0";
export var searchHeaderDark = "_6l-1";